export const __BrandInfoLang = {
    sale: 'فروش',
    share: 'اشتراک گذاری',
    contact_numbers: 'شماره های تماس:',
    address: 'آدرس:',
    social_networks: 'شبکه های اجتماعی:',
    copy_alert: 'لینک برند با موفقیت در کلیپ بورد شما ذخیره شد.',
};
